
import React, { useEffect, useMemo, useState } from "react";
import QRCode from "react-qr-code";
import ApiCustom from "../../utils/ApiCustom";

const cleanValue = (value) => {
  const normalized = String(value ?? "").trim();
  if (!normalized || normalized.toLowerCase() === "null") {
    return "";
  }
  return normalized;
};

const normalizeWebsiteUrl = (website) => {
  if (!website) {
    return "";
  }

  if (/^https?:\/\//i.test(website)) {
    return website;
  }

  return `https://${website}`;
};

const CompanyQrModal = ({ company, onClose }) => {
  const [companyDetail, setCompanyDetail] = useState(company || null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const getCompanyDetail = async () => {
      if (!company?.id) {
        if (isMounted) {
          setError("Không tìm thấy thông tin hội viên");
          setIsLoading(false);
        }
        return;
      }

      try {
        const res = await ApiCustom.get(`/company-show-by-id/${company.id}`);
        if (isMounted) {
          setCompanyDetail(res.data?.data || company);
        }
      } catch (err) {
        if (isMounted) {
          setCompanyDetail(company);
          setError("Không thể tải thông tin hội viên");
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    getCompanyDetail();

    return () => {
      isMounted = false;
    };
  }, [company]);

  const website = cleanValue(companyDetail?.websiteOrHotline);
  const address = cleanValue(companyDetail?.businessAddress);

  const targetUrl = useMemo(() => {
    if (website) {
      return normalizeWebsiteUrl(website);
    }

    if (address) {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
      )}`;
    }

    return "";
  }, [website, address]);

  if (!company) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-base-100 rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-5 border-b">
          <div>
            <h2 className="text-xl font-semibold">QR hội viên</h2>
            <p className="text-sm text-gray-500 mt-1">{company.companyName}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="btn btn-sm btn-ghost"
          >
            ✕
          </button>
        </div>

        <div className="p-6 flex flex-col items-center">
          {isLoading ? (
            <div className="py-12 flex items-center gap-2">
              <span className="loading loading-spinner loading-sm"></span>
              <span>Đang tải...</span>
            </div>
          ) : targetUrl ? (
            <>
              <div className="bg-white p-4 rounded-lg border">
                <QRCode value={targetUrl} size={240} />
              </div>

              <p className="mt-4 text-sm text-gray-600 text-center">
                {website
                  ? "Quét mã để mở website của hội viên."
                  : "Quét mã để mở địa chỉ hội viên trên Google Maps."}
              </p>

              <a
                href={targetUrl}
                target="_blank"
                rel="noreferrer"
                className="mt-3 text-sm text-blue-600 hover:underline break-all text-center"
              >
                {website || address}
              </a>
            </>
          ) : (
            <div className="py-10 text-center text-red-500">
              {error || "Không có website hoặc địa chỉ để tạo QR"}
            </div>
          )}
        </div>

        <div className="flex justify-end p-5 border-t">
          <button type="button" onClick={onClose} className="btn btn-sm">
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyQrModal;


